import { render, staticRenderFns } from "./BellNotificationMonitor.vue?vue&type=template&id=78c7afdc"
import script from "./BellNotificationMonitor.vue?vue&type=script&lang=ts"
export * from "./BellNotificationMonitor.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports